import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type RoleSource, type RoleTarget} from 'web-app/util/graphql/api-types';
import type * as Types from 'web-app/react/manage-employees/roles/permission-role-form/types';
import {type RoleSiteFragment} from 'web-app/react/manage-employees/roles/__generated__/queries.api-types';
import {type ValidInstitutionSetTypes} from 'web-app/react/manage-employees/roles/permission-role-form/helpers';

const domain = 'MODALS/PERMISSON_ROLE_FORM';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    ({
        institutionSetId,
        institutionSetType,
        availableSites,
        source,
        target,
        roleId,
        canCreateRoles,
        canEditRoles,
        mode,
    }: {
        institutionSetId: string;
        institutionSetType: ValidInstitutionSetTypes;
        availableSites: RoleSiteFragment[];
        source: RoleSource;
        target: RoleTarget;
        roleId: string;
        canCreateRoles: boolean;
        canEditRoles: boolean;
        mode: Types.PermissionRoleFormMode;
    }) => ({
        institutionSetId,
        institutionSetType,
        availableSites,
        source,
        target,
        roleId,
        canCreateRoles,
        canEditRoles,
        mode,
    }),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
